import { useLingui } from "@lingui/react/macro";
import { List, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DocHeading } from "@/components/docs/DocHeading.tsx";
import { DocsContent } from "@/components/docs/DocsContent.tsx";

export const Route = createFileRoute("/docs/platform/design-principles")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useLingui();

  return (
    <DocsContent>
      <Title order={1} size="h2">{t`Technical design principles`}</Title>
      <Text>{t`REALity is designed according to the following principles.`}</Text>

      <DocHeading order={2} size="h3">{t`Modularity`}</DocHeading>
      <Text>
        {t`Deployments can select the components they need. This makes it possible to support different user groups, data sources and applications without requiring one large solution for every situation.`}
      </Text>

      <DocHeading
        order={2}
        size="h3"
      >{t`Abstraction of data sources`}</DocHeading>
      <Text>
        {t`REALity hides much of the complexity of the underlying data providers. A user or application can use a common interface even if the data is obtained from different services. This also makes it possible to change or supplement the underlying source without changing every application that uses REALity.`}
      </Text>

      <DocHeading order={2} size="h3">{t`Modern standards`}</DocHeading>
      <Text>{t`REALity favours modern standards such as:`}</Text>
      <List withPadding>
        <List.Item>OGC API</List.Item>
        <List.Item>GraphQL</List.Item>
        <List.Item>{t`Standard web-based authentication and authorisation mechanisms.`}</List.Item>
      </List>
      <Text>
        {t`Compatibility layers for older standards, such as WMS and WFS, may also be provided where needed.`}
      </Text>

      <DocHeading order={2} size="h3">{t`Centralised control`}</DocHeading>
      <Text>
        {t`Authentication, permissions, transaction recording and cost allocation are handled centrally wherever possible. This provides a consistent experience across applications and user groups.`}
      </Text>
    </DocsContent>
  );
}
